import React, { useEffect, useState } from 'react';
import { Users, FileCheck, Award, TrendingUp } from 'lucide-react';

const StatsCounter = () => {
  const [counts, setCounts] = useState({
    clients: 0,
    cases: 0,
    experience: 0,
    success: 0
  });

  const stats = [
    {
      icon: Users,
      end: 500,
      label: 'Задоволених клієнтів',
      key: 'clients'
    },
    {
      icon: FileCheck,
      end: 1200,
      label: 'Успішних справ',
      key: 'cases'
    },
    {
      icon: Award,
      end: 15,
      label: 'Років досвіду',
      key: 'experience',
      suffix: '+'
    },
    {
      icon: TrendingUp,
      end: 95,
      label: 'Відсоток успіху',
      key: 'success',
      suffix: '%'
    }
  ];

  useEffect(() => {
    const duration = 2000; // 2 seconds
    const steps = 60;
    const stepDuration = duration / steps;

    const timers = stats.map(stat => {
      const increment = stat.end / steps;
      let current = 0;
      
      return setInterval(() => {
        current += increment;
        if (current >= stat.end) {
          setCounts(prev => ({ ...prev, [stat.key]: stat.end }));
          clearInterval(timers[stats.indexOf(stat)]);
        } else {
          setCounts(prev => ({ ...prev, [stat.key]: Math.floor(current) }));
        }
      }, stepDuration);
    });

    return () => timers.forEach(timer => clearInterval(timer));
  }, []);

  return (
    <section className="section-container section-alt">
      <div className="content-wrapper">
        <div className="stats-grid">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div key={index} className="stat-card">
                <div className="stat-icon">
                  <Icon size={40} />
                </div>
                <div className="stat-number">
                  {counts[stat.key]}{stat.suffix || ''}
                </div>
                <div className="stat-label">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsCounter;